import { grantOf, type GuestGrant } from '../data/shareLinks'

/**
 * The guest marker (GRO-83 design, "The guest marker"): which company this browser last
 * held a guest grant for. It holds nothing secret, so `localStorage` is enough; its only
 * use is to tell an ended guest from a visitor who never had a link, once the guest
 * cookie is gone. Every storage access is wrapped: without storage there is no marker.
 */
const KEY = 'grovus.guest'

export function writeGuestMarker(grant: GuestGrant) {
  const { companyId, companyName, expiresAt } = grant
  try {
    localStorage.setItem(KEY, JSON.stringify({ companyId, companyName, expiresAt }))
  } catch {
    // No storage: an ended link lands on the sign-in screen instead.
  }
}

export function readGuestMarker(): GuestGrant | null {
  try {
    const raw = localStorage.getItem(KEY)
    return raw === null ? null : grantOf(JSON.parse(raw))
  } catch {
    return null
  }
}

export function clearGuestMarker() {
  try {
    localStorage.removeItem(KEY)
  } catch {
    // Nothing stored.
  }
}
